import { CEHelloBase } from './ce-hello-base'


export class CEHello extends CEHelloBase {

}